export enum WebsiteHeroSectionTab {
    IN_CINEMAS = 'in_cinemas',
    COMING_SOON = 'coming_soon'
}
